export const TASK_FORM_LABELS = {
  // Navigation / page title
  NAV_TITLE: 'Formularze zadań',
  PAGE_TITLE: 'Formularze zadań',

  // List page — empty state
  EMPTY_STATE_TITLE: 'Brak dostępnych formularzy.',
  EMPTY_STATE_DESCRIPTION: 'Twórz formularze i zarządzaj nimi dla różnych ról.',

  // Buttons
  BUTTON_CREATE: 'Utwórz formularz zadania',
  BUTTON_CANCEL: 'Anuluj',
  BUTTON_PREVIEW: 'Podgląd',
  BUTTON_SAVE: 'Zapisz formularz',
  BUTTON_SAVING: 'Zapisywanie...',
  BUTTON_BACK_TO_EDIT: 'Wróć do edycji',
  BUTTON_ADD_SECTION: 'Dodaj sekcję',
  BUTTON_ADD_FIELD: 'Dodaj pole',
  BUTTON_CLOSE_PREVIEW: 'Zamknij podgląd',

  // Create page — header
  CREATE_TITLE: 'Utwórz formularz zadania',
  BREADCRUMB_LIST: 'Formularze zadań',
  BREADCRUMB_CREATE: 'Utwórz formularz zadania',

  ALERT_TEXT:
    'Ten formularz będzie używany przez techników do rejestrowania szczegółów zadań serwisowych podczas realizacji zgłoszeń. Skonfiguruj pola wymagane do wykonania zadania.',

  // Form details section
  SECTION_FORM_DETAILS: 'Szczegóły formularza',
  FORM_DETAILS_DESC:
    'Podaj podstawowe informacje identyfikacyjne i kontekst, aby pomóc technikom rozpoznać i zrozumieć przeznaczenie tego formularza.',
  FIELD_FORM_NAME: 'Nazwa formularza',
  FIELD_FORM_DESCRIPTION: 'Opis',

  // Sections
  SECTION_SECTIONS: 'Sekcje',
  SECTIONS_DESC:
    'Twórz logiczne grupy pól, aby uporządkować informacje i ułatwić technikom poruszanie się po długich formularzach.',
  SECTION_NAME_PLACEHOLDER: 'Nazwa sekcji',
  SECTION_DESC_PLACEHOLDER: 'Opis (Opcjonalne)',

  // Fields inside a section
  FIELDS_SECTION_TITLE: 'Pola formularza',
  FIELDS_SECTION_DESC:
    'Określ informacje, które technicy muszą podać, aby prawidłowo udokumentować i zrealizować zgłoszenie serwisowe.',
  FIELD_LABEL_PLACEHOLDER: 'Etykieta pola',
  FIELD_TYPE_LABEL: 'Typ pola',
  FIELD_OPTIONAL: 'Opcjonalne',
  FIELDS_REQUIRED_NOTE:
    'Wszystkie pola są domyślnie wymagane. Zaznacz „Opcjonalne" tylko wtedy, gdy Technik może pominąć to pole.',

  // Options (dropdown / radio / checkbox)
  OPTIONS_LABEL: 'Opcje',
  OPTIONS_DESC:
    'Kliknij ostatnią dostępną opcję, aby automatycznie dodać nowy wybór do listy.',
  MULTI_SELECT: 'Wielokrotny wybór',

  // Number range
  NUMBER_RANGE_SECTION: 'Liczba z zakresem',
  NUMBER_RANGE_ALERT:
    'Określ zakres prawidłowy dla tego odczytu. Wartości poniżej minimum zostaną oznaczone jako Niskie, a wartości powyżej maksimum jako Wysokie.',
  NUMBER_RANGE_TOOL_TIP_INFO:
    'Profile image requirements\nPNG, JPG, or JPEG format\nMaximum file size: 5 MB',
  MIN_VALUE: 'Wartość minimalna',
  MAX_VALUE: 'Wartość maksymalna',
  TO_LABEL: 'do',
  UNIT_LABEL: 'Jedn.',

  // Attachment
  ATTACHMENT_CONFIG_LABEL: 'Konfiguracja plików',
  ATTACHMENT_CONFIG_DESC:
    'Skonfiguruj dozwolone typy plików, limity rozmiaru i maksymalną liczbę przesyłanych plików.',
  ACCEPTED_FILE_TYPES: 'Dozwolone formaty plików',
  MAX_FILE_SIZE: 'Maks. rozmiar pliku (MB)',
  MAX_FILES: 'Maks. liczba przesyłanych plików',

  // Signature section
  SIGNATURE_SECTION: 'Podpis',
  SIGNATURE_DESC:
    'Dodaj pole podpisu, aby uzyskać potwierdzenie technika w momencie przesyłania formularza.',
  SIGNATURE_REQUIRED: 'Wymagane',

  // Field types display names
  FIELD_TYPE_TEXT: 'Tekst (jednowierszowy) (100 znaków)',
  FIELD_TYPE_TEXTAREA: 'Tekst (wielowierszowy) (500 znaków)',
  FIELD_TYPE_NUMBER: 'Liczba',
  FIELD_TYPE_NUMBER_RANGE: 'Liczba z zakresem',
  FIELD_TYPE_DATE: 'Data',
  FIELD_TYPE_DATE_RANGE: 'Zakres dat',
  FIELD_TYPE_DROPDOWN: 'Lista rozwijana',
  FIELD_TYPE_RADIO: 'Przycisk jednokrotnego wyboru',
  FIELD_TYPE_CHECKBOX: 'Pole wyboru',
  FIELD_TYPE_ATTACHMENT: 'Załącznik',
  FIELD_TYPE_PRICE: 'Cena',

  // List page
  LIST_SEARCH_PLACEHOLDER: 'Szukaj po nazwie lub ID',
  LIST_COL_NAME: 'Nazwa',
  LIST_COL_ID: 'ID formularza',
  LIST_COL_DESC: 'Opis',
  LIST_COL_DATE: 'Data utworzenia',
  LIST_COL_ACTIONS: 'Akcje',
  LIST_ACTION_VIEW: 'Podgląd',
  LIST_ACTION_EDIT: 'Edytuj',
  LIST_NO_DATA_TITLE: 'Brak dostępnych formularzy.',
  LIST_NO_DATA_DESC: 'Twórz formularze i zarządzaj nimi dla różnych ról.',
  LIST_NO_RESULTS_TITLE: 'Brak wyników.',
  LIST_NO_RESULTS_DESC: 'Spróbuj zmienić kryteria wyszukiwania.',

  // Success / error feedback
  CREATE_SUCCESS: 'Formularz zadania został pomyślnie utworzony.',

  // Validation errors
  ERROR_FORM_NAME_REQUIRED: 'To pole jest wymagane.',
  ERROR_FORM_NAME_MAX: 'Nazwa formularza może mieć maksymalnie 200 znaków.',
  ERROR_FORM_DESCRIPTION_REQUIRED: 'To pole jest wymagane.',
  ERROR_DESCRIPTION_MAX: 'Opis może mieć maksymalnie 500 znaków.',
  ERROR_SECTION_NAME_REQUIRED: 'To pole jest wymagane.',
  ERROR_SECTION_DESC_REQUIRED: 'To pole jest wymagane.',
  ERROR_SECTION_MIN_FIELDS: 'To pole jest wymagane.',
  ERROR_FIELD_LABEL_REQUIRED: 'To pole jest wymagane.',
  ERROR_FIELD_LABEL_MAX: 'Etykieta pola może mieć maksymalnie 30 znaków.',
  ERROR_FIELD_TYPE_REQUIRED: 'To pole jest wymagane.',
  ERROR_RANGE_MAX_GT_MIN: 'Maximum value must be greater than minimum value.',
  ERROR_FIELD_MIN_OPTIONS: 'To pole jest wymagane.',
  ERROR_OPTION_LABEL_REQUIRED: 'To pole jest wymagane.',
  ERROR_MAX_SECTIONS: 'Formularz może zawierać maksymalnie 10 sekcji.',
  ERROR_MAX_FIELDS: 'Sekcja może zawierać maksymalnie 10 pól.',
  ERROR_MAX_OPTIONS: 'Lista może zawierać maksymalnie 10 opcji.',
  ERROR_OPTION_MAX: 'Opcja może mieć maksymalnie 200 znaków.',
  ERROR_UNIT_MAX: 'Jednostka może mieć maksymalnie 10 znaków.',
  ERROR_NO_SECTIONS: 'Formularz musi zawierać co najmniej jedną sekcję.',

  // Tooltips
  TOOLTIP_REORDER_SECTION: 'Zmień kolejność sekcji',
  TOOLTIP_REORDER_FIELD: 'Zmień kolejność pól',
  TOOLTIP_REORDER_OPTION: 'Zmień kolejność opcji',
  TOOLTIP_DELETE_SECTION: 'Usuń sekcję',
  TOOLTIP_DELETE_FIELD: 'Usuń pole',
  TOOLTIP_DELETE_OPTION: 'Usuń opcję',
  TOOLTIP_MAX_SECTIONS: 'Maximum of 10 sections can be added',
  TOOLTIP_MAX_FIELDS: 'Maximum of 10 form fields can be added per section',

  // Cancel modal
  CANCEL_MODAL_TITLE: 'Czy na pewno chcesz anulować?',
  CANCEL_MODAL_DESC: 'Wszystkie niezapisane dane zostaną utracone.',
  CANCEL_MODAL_CONFIRM: 'Tak, anuluj',
  CANCEL_MODAL_BACK: 'Wróć',

  // Preview
  PREVIEW_TITLE: 'Podgląd formularza',
  PREVIEW_NOTE:
    'Tak formularz zobaczy Technik. Możesz korzystać z pól, aby przetestować działanie — wprowadzone dane nie zostaną zapisane.',

  // Edit form page
  EDIT_TITLE: 'Edytuj formularz zadania',
  EDIT_SUCCESS: 'Formularz zadania został pomyślnie zaktualizowany.',
  EDIT_ERROR_GENERIC: 'Nie udało się załadować formularza. Spróbuj ponownie.',

  // View form page
  VIEW_PAGE_TITLE: 'Podgląd formularza zadania',
  VIEW_BREADCRUMB: 'Podgląd formularza zadania',
  BUTTON_EDIT_FORM: 'Edit Task Form',
  VIEW_TAB_DETAILS: 'Szczegóły formularza',
  VIEW_TAB_TECHNICIANS: 'Assigned Technicians',
  VIEW_LABEL_FORM_ID: 'ID formularza',
  VIEW_LABEL_FORM_NAME: 'Nazwa formularza',
  VIEW_LABEL_DESCRIPTION: 'Opis',
  VIEW_LABEL_CREATED_AT: 'Data utworzenia',
  VIEW_ERROR_NOT_FOUND: 'Nie znaleziono formularza.',
  VIEW_ERROR_GENERIC: 'Nie udało się załadować formularza. Spróbuj ponownie.',
  VIEW_TECHNICIANS_PLACEHOLDER: 'Brak przypisanych techników.',
} as const;

export const FIELD_TYPE_OPTIONS = [
  { value: 'text', label: TASK_FORM_LABELS.FIELD_TYPE_TEXT },
  { value: 'textarea', label: TASK_FORM_LABELS.FIELD_TYPE_TEXTAREA },
  { value: 'number', label: TASK_FORM_LABELS.FIELD_TYPE_NUMBER },
  { value: 'number_range', label: TASK_FORM_LABELS.FIELD_TYPE_NUMBER_RANGE },
  { value: 'date', label: TASK_FORM_LABELS.FIELD_TYPE_DATE },
  { value: 'date_range', label: TASK_FORM_LABELS.FIELD_TYPE_DATE_RANGE },
  { value: 'price', label: TASK_FORM_LABELS.FIELD_TYPE_PRICE },
  { value: 'dropdown', label: TASK_FORM_LABELS.FIELD_TYPE_DROPDOWN },
  { value: 'radio', label: TASK_FORM_LABELS.FIELD_TYPE_RADIO },
  { value: 'checkbox', label: TASK_FORM_LABELS.FIELD_TYPE_CHECKBOX },
  { value: 'attachment', label: TASK_FORM_LABELS.FIELD_TYPE_ATTACHMENT },
] as const;

export const ACCEPTED_FILE_TYPE_OPTIONS = [
  'PDF',
  'JPG',
  'JPEG',
  'PNG',
  'DOC',
  'DOCX',
  'XLS',
  'XLSX',
  'CSV',
  'TXT',
] as const;

export const MAX_SECTIONS = 10;
export const MAX_FIELDS = 10;
export const MAX_OPTIONS = 10;
export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILES = 5;
